import styled from "styled-components";
import { calculateResponsiveSize } from "helpers/calculateResponsiveSize";
import { mediaMax } from "helpers/mediaQueries";
import CloseIconWhite from "icons/close-icon-white.svg";

export const SpecialBarWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #1e1e1e;
  color: #fff;
      z-index: 999;
  padding:20px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-100%);
  opacity: 0;
  transition: transform 0.4s ease-out, opacity 0.4s ease-out;
  animation: slideDown 0.4s ease-out forwards;

  ${({ $isClosing }) =>
    $isClosing &&
    `
    animation: slideUp 0.4s ease-out forwards;
  `}

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(-100%);
      opacity: 0;
    }
  }

  ${mediaMax("tabletLandscape")} {
    padding:20px 20px;
  
  }
`;

export const SpecialBarContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 20px;
  row-gap: 10px;
  width: 100%;
  max-width: 90%;
  flex-wrap: wrap;

  ${mediaMax("tabletLandscape")} {

    text-align: center;
  }
`;

export const SpecialBarTitle = styled.span`
  font-family: proxima_nova, sans-serif;
  font-size: ${calculateResponsiveSize(16)};
  line-height: ${calculateResponsiveSize(20)};
  color: #fff;
  text-transform: uppercase;
  letter-spacing: ${calculateResponsiveSize(1)};
  font-weight: 600;

  ${mediaMax("desktopSm")} {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const SpecialBarDescription = styled.span`
  font-family: proxima_nova, sans-serif;
  font-size: ${calculateResponsiveSize(12)};
  line-height: ${calculateResponsiveSize(16)};
  color: #fff;
  text-transform: uppercase;
  letter-spacing: ${calculateResponsiveSize(1)};

  ${mediaMax("desktopSm")} {
    font-size: 11px;
    line-height: 14px;
  }
`;

export const SpecialBarCTA = styled.a`
  font-family: proxima_nova, sans-serif;
  font-size: ${calculateResponsiveSize(12)};
  line-height: ${calculateResponsiveSize(16)};
  color: #fff;
  text-transform: uppercase;
  letter-spacing: ${calculateResponsiveSize(1)};
  text-decoration: underline;
  transition: opacity 0.3s ease;
  white-space: nowrap;

  &:hover {
    opacity: 0.7;
  }

  ${mediaMax("desktopSm")} {
    font-size: 11px;
    line-height: 14px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 20px;
  top: 15px;
  background: transparent;
  border: 0;
  cursor: pointer;
  width: 18px;
  height: 18px;
  background-image: url(${CloseIconWhite});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0;
  opacity: 0.8;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }

  ${mediaMax("tabletLandscape")} {
    right: 20px;
    width: 15px;
    height: 15px;
  }
`;

